import { translatableText } from '../../utils/translatable-text';
import {
    Context,
    AppContext,
    isProductContext,
    getBreadcrumbTitle,
    ThemeContext
} from '../../../content/context-utils';

interface Crumb {
    title: string;
    slug: string;
    id: string;
}

export const getContextBreadcrumbs = (
    context: Context | AppContext | ThemeContext,
    displayResourcesBreadcrumb: boolean,
    displayReleaseNotesBreadcrumb = false
) => {
    // First up is the hardcoded Atlassian Support crumb
    const crumbs = [
        {
            id: '/',
            slug: '/',
            title: translatableText.atlassianSupport.text
        }
    ];

    // Then the relevant product
    if (context) {
        if (
            isProductContext(context) &&
            Object.keys(context).length > 0 &&
            context.hasProductLandingPage
        ) {
            crumbs.push({
                id: context.id,
                slug: context.deploymentUrls.default,
                title: context.productNameReference.productName
            });
        }

        // Display Resources breadcrumb if collection, topic set or topic
        if (displayResourcesBreadcrumb) {
            crumbs.push({
                id: 'resources',
                slug: context.docsHomeSlug,
                title: getBreadcrumbTitle(context)
            });
        }
    }

    // Or the release notes page
    if (displayReleaseNotesBreadcrumb) {
        crumbs.push({
            id: 'release-notes',
            slug: 'release-notes',
            title: 'Release Notes'
        });
    }

    return crumbs;
};

// This method returns JSON-LD structured data breadcrumb markup to assist with SEO
// https://developers.google.com/search/docs/data-types/breadcrumb
export const getStructuredData = (crumbs: Crumb[]) => {
    const listItems = crumbs.map((crumb, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        item: {
            '@id': crumb.slug,
            name: crumb.title
        }
    }));

    return JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: listItems
    });
};
